export const navLinks = [
  { label: '首页', href: '/' },
  { label: '游戏大厅', href: '/categories' },
  { label: '资讯中心', href: '/articles' },
  { label: '会员福利', href: '/#vip-benefits' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  games: {
    title: '热门游戏',
    links: [
      { label: '棋牌游戏', href: '/category/board' },
      { label: '电子游戏', href: '/category/slots' },
      { label: '捕鱼游戏', href: '/category/fishing' },
      { label: '体育竞猜', href: '/category/sports' },
      { label: '真人视讯', href: '/category/live' },
    ],
  },
  service: {
    title: '客户服务',
    links: [
      { label: '新手引导', href: '/articles' },
      { label: '常见问题', href: '/#faq' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户协议', href: '/article/terms' },
      { label: '隐私政策', href: '/article/privacy' },
    ],
  },
  about: {
    title: '关于九游',
    links: [
      { label: '品牌故事', href: '/about' },
      { label: '信誉资质', href: '/about#credentials' },
      { label: '合作伙伴', href: '/about#partners' },
      { label: '加入我们', href: '/about#join' },
    ],
  },
};

export const footerContact = {
  phone: '400-888-9999',
  email: 'service@jiuyouyule.com',
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  workingHours: '7×24小时全天候服务',
};